"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Audiences_1 = require("../../constants/Audiences");
class ScopeGuard extends react_1.default.Component {
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            claims: mobx_1.computed,
        });
    }
    get claims() {
        const user = this.props.auth0.user ?? null;
        if (null === user) {
            return [];
        }
        const claims = user[Audiences_1.Audiences.PORTAL] ?? null;
        return claims?.scope ?? [];
    }
    render() {
        if (this.props.scopes.every((scope) => this.claims.includes(scope))) {
            return this.props.children;
        }
        return this.props.fallback ?? null;
    }
}
exports.default = (0, auth0_react_1.withAuth0)((0, mobx_react_1.observer)(ScopeGuard));
